import { Box } from '@mui/material';
import { getSigners } from 'lib/api/business';
import {
  translateCountry,
  translateMaritalStatus,
} from 'lib/consts/usersFields';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions, {
  CustomButtonProps,
} from 'lib/designSystem/HeaderWithActions';
import Table from 'lib/designSystem/Table';
import AssignSigner from 'pages/BusinessProfile/Contracts/Signers/Components/AssignSigner';
import CreateSigner from 'pages/BusinessProfile/Contracts/Signers/Components/CreateSigner';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'services/redux/store';

const Signers = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const identifier = user?.businessIdentifier;
  const [openCreateSigner, setOpenCreateSigner] = useState(false);
  const [openAssignSigner, setOpenAssignSigner] = useState(false);
  const { data, isPending } = getSigners(dispatch, identifier);

  const signers =
    data?.map((signer) => ({
      ...signer,
      translateCountry: translateCountry(signer.country),
      translateMaritalStatus: translateMaritalStatus(signer.maritalStatus),
    })) ?? [];

  const tableHeaders = [
    { key: 'identifier', label: 'Rut' },
    { key: 'name', label: 'Nombre' },
    { key: 'email', label: 'Email', type: 'copyable' },
    { key: 'phone', label: 'Teléfono' },
    { key: 'translateCountry', label: 'Nacionalidad' },
    { key: 'profession', label: 'Profesión' },
    { key: 'translateMaritalStatus', label: 'Estado civil' },
  ];

  const buttons: CustomButtonProps[] = [
    {
      name: 'Asignar firmante',
      color: 'secondary',
      action: () => setOpenAssignSigner(true),
    },
    {
      name: 'Crear firmante',
      color: 'primary',
      action: () => setOpenCreateSigner(true),
    },
  ];

  if (isPending) return <CenteredCircularProgress type="dialog" />;

  return (
    <>
      <Box mt={2}>
        <HeaderWithActions
          title="Aca podras ver una lista con los firmantes de tu empresa."
          variant="body1"
          buttons={buttons}
          type="subHeader"
        />
        <Table data={signers} dataHeaders={tableHeaders} />
      </Box>
      <CreateSigner
        open={openCreateSigner}
        setOpen={setOpenCreateSigner}
        businessIdentifier={user?.businessIdentifier}
      />
      <AssignSigner open={openAssignSigner} setOpen={setOpenAssignSigner} />
    </>
  );
};

export default Signers;
